var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.className }, [
    _vm.activeOffers ? _c("h5", [_vm._v("Angebote")]) : _vm._e(),
    _vm._v(" "),
    _c("ul", {
      staticClass: "list-style",
      domProps: { innerHTML: _vm._s(_vm.getOfferText) }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }